module.exports = __webpack_public_path__ + "static/media/hand-money.5e9dcda9.svg";